<template>
    <div class="flex-page">
        <a-form class="ctrl" layout="inline">

            <a-form-item>
                <a-button type="primary" @click="showInfo">新增</a-button>
            </a-form-item>

            <a-form-item label="名称">
                <a-input style="min-width: 200px" v-model="search.name" placeholder="请输入名称"></a-input>
            </a-form-item>

            <a-form-item label="活动开始时间">
                <a-date-picker  v-model="search.start_time" />
            </a-form-item>

            <a-form-item label="活动结束时间">
                <a-date-picker  v-model="search.end_time" />
            </a-form-item>

            <a-form-item>
                <a-button type="primary" @click="doSearch">搜索</a-button>
            </a-form-item>
        </a-form>

        <div class="article-page">
            <div class="list">
                <div class="statistics">共{{ amount }}条</div>
                <a-table bordered :dataSource="list" :columns="columns" :pagination="false" size="small"
                    :rowKey="(record) => record.id">
                    <template slot="time" slot-scope="text, record">
                        {{ moment(record.start_time).format("YYYY-MM-DD HH:mm") }} ~ {{
                            moment(record.end_time).format("YYYY-MM-DD HH:mm") }}
                    </template>
                    <template slot="caozuo" slot-scope="text, record">
                        <a-button style="margin-left: 5px" size="small" @click="editInfo(record)" type="primary"> 编辑
                        </a-button>
                        <a-button style="margin-left: 5px" size="small" @click="showCode(record)" type="primary"> 生成二维码
                        </a-button>

                        <a-button style="margin-left: 5px" size="small" @click="joinRecord(record.id)" type="primary"> 参加记录
                        </a-button>

                        <a-popconfirm v-if="record.status != -2" title="确定要删除吗" @confirm="changeStatus(record.id, 0)" okText="确定" cancelText="取消">
                            <a-button style="margin-left: 5px" type="danger" size="small">
                                删除
                            </a-button>
                        </a-popconfirm>


                    </template>
                </a-table>
                <a-pagination @change="onChange" :total="amount" :defaultPageSize="50" :defaultCurrent="search.now_page"
                    showQuickJumper class="margin15" />
            </div>
        </div>

        <a-modal :title="infoData.title" :visible="infoData.show" :width="800" @ok="doInfo" @cancel="cancelInfo">
            <a-form style="max-height: 60vh; overflow: auto;" class="" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-form-item label="名称">
                    <a-input style="width: 300px;" v-model="infoData.name" />
                </a-form-item>

                <a-form-item label="开始时间">
                    <a-date-picker style="width: 300px;" :showTime="{ defaultValue: moment('09:00:00', 'HH:mm:ss') }"
                        v-model="infoData.start_time" />
                </a-form-item>

                <a-form-item label="结束时间">
                    <a-date-picker style="width: 300px;" :showTime="{ defaultValue: moment('09:00:00', 'HH:mm:ss') }"
                        v-model="infoData.end_time" />
                </a-form-item>

                <a-form-item label="贡献值">
                    <a-input-number v-model="infoData.gongxianzhi" :min="0"></a-input-number>
                </a-form-item>
                <a-form-item label="活动海报">
                    <UploadFile v-if="infoData.show" @callback="uploaded2" :mult="false" folder="exhibition" />
                    <img v-if="infoData.thumb" style="max-height: 200px" :src="this.API + infoData.thumb" alt="">
                </a-form-item>

                <a-form-item label="活动简介">
                    <Editor
                        @callback="updateEditor"
                        :data="infoData.content"
                        folder="article"
                    />
                </a-form-item>

                
            </a-form>
        </a-modal>


        <a-modal :title="'二维码'" :width="800" :visible="code.show" @ok="cancelCode" @cancel="cancelCode">
            <div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
                <img style="width: 500px;margin: 0 auto;" :src="code.QRImgUrl" />
            </div>
        </a-modal>


    </div>
</template>
  
<style lang='scss' scoped>
</style>
  
<script>
import moment from 'moment'
import QRCode from "qrcode"
import Editor from "../../../components/editor";
import UploadFile from "../../../components/uploadFile";

export default {
    components: { Editor, UploadFile },
    data() {
        return {
            formItemLayout: {
                labelCol: {
                    span: 4,
                },
                wrapperCol: {
                    span: 20,
                },
            },
            columns: [
                {
                    title: "名称",
                    dataIndex: "name",
                },
                {
                    title: "时间",
                    dataIndex: "time",
                    scopedSlots: {
                        customRender: "time",
                    },
                },
                {
                    title: "贡献值",
                    dataIndex: "gongxianzhi",
                },
                {
                    title: "操作",
                    dataIndex: "caozuo",
                    scopedSlots: {
                        customRender: "caozuo",
                    },
                },
            ],
            search: {
                name: "",
                start_time: null,
                end_time: null,
                now_page: 1,
            },
            amount: 0,
            pages: 1,
            list: [],
            infoData: {
                show: false,
                name: '',
                start_time: null,
                end_time: null,
                gongxianzhi: 0,
                title: '添加活动',
                content: null,
                thumb: null
            },
            code: {
                show: false,
                QRImgUrl: ''
            }
        };
    },
    watch: {

    },
    async created() {
        this.getList();

    },
    mounted() {
    },
    methods: {
        moment,
        doSearch() {
            this.search.now_page = 1;
            this.getList();
        },
        async getList() {
            const search = JSON.parse(JSON.stringify(this.search))
            const r = await this.$axios.get("/shellCity/getHuodongList", { params: search });
            this.list = r.list;
            this.amount = r.amount;
        },
        onChange(e) {
            this.search.now_page = e;
            this.getList();
        },
        showInfo() {
            this.infoData = {
                show: true,
                name: '',
                start_time: null,
                end_time: null,
                gongxianzhi: 0,
                content: null,
                thumb: null,
                title: '添加活动'
            }
        },
        editInfo(item) {
            this.infoData = {
                show: true,
                id: item.id,
                name: item.name,
                start_time: moment(item.start_time),
                end_time: moment(item.end_time),
                gongxianzhi: item.gongxianzhi,
                content: item.content,
                thumb: item.thumb,
                title: '编辑活动'
            }
        },
        uploaded2(file) {
            this.infoData.thumb = file.file_path;
        },
        async doInfo() {

            if (!this.infoData.title) return this.$message.error('请填写场次');
            if (!this.infoData.start_time) return this.$message.error('请选择开始时间');
            if (!this.infoData.end_time) return this.$message.error('请选择结束时间');

            if (this.infoData.id) {
                // 编辑
                const r = await this.$axios.post("/shellCity/editHuodong", this.infoData);
                if (r.status == 1) {
                    this.cancelInfo()
                    this.getList()
                }
            } else {
                // 添加
                const r = await this.$axios.post("/shellCity/addHuodong", this.infoData);
                if (r.status == 1) {
                    this.cancelInfo()
                    this.getList()
                }
            }
        },
        cancelInfo() {
            this.infoData = {
                show: false,
                name: '',
                start_time: null,
                end_time: null,
                gongxianzhi: 0,
                content: null,
                thumb: null,
                title: '添加活动'
            }
        },
        showCode(record) {
            this.code.show = true
            QRCode.toDataURL(this.$config.wechatApi + '/city/joinActivity?id=' + String(record.id), { errorCorrectionLevel: 'L', margin: 2, width: 800 }, (err, url) => {
                if (err) throw err
                this.code.QRImgUrl= url
            })
        },
        cancelCode() {
            this.code = {
                show: false,
                QRImgUrl: ''
            }
        },
        joinRecord(id) {
            this.$router.push('/shellCity/huodong/joinList?id=' + id)
        },
        async changeStatus(id, status) {
            const r = await this.$axios.post("/shellCity/changeHuodongStatus", {id: id, status: status});
            if(r.status == 1) {
                this.getList();
            }
        },
        updateEditor(data) {
            this.infoData.content = data;
        },
    },
};
</script>
  
<style>
</style>
